// Digital Lite Linked Product 
export const linkedProductMessage = "This is a Linked product that is being updated from Digital Lite to Digital. Images for this item were automatically approved.";
